
export enum VISIBILITY_TYPE_ENUM {
  Public = "public",
  ContactToSale = "contact_to_sale",
  Private = "private",
  FreeTrial = "free_trial",
}

export enum PLATFORM_ENUM {
  Pwa = "pwa",
  Mobile = "mobile",
  Desktop = "desktop",
}

export enum CREDIT_TYPE_ENUM {
  Whatsapp = "whatsapp",
  EInvoice = "e_invoice",
  EWayBill = "e_way_bill",
  Ai = "ai",
}

export enum CREDIT_LEDGER_REASON_ENUM {
  PackageIncluded = "package_included",
  PlanPurchase = "plan_purchase",
  AdminGrant = "admin_grant",
  Used = "used",
  Returned = "returned",
}

export enum SUBSCRIPTION_SOURCE_ENUM {
  FreeTrial = "free_trial",
  Purchase = "purchase",
  AdminAssignment = "admin_assignment",
}

export enum SUBSCRIPTION_END_REASON_ENUM {
  Replaced = "replaced",
  Cancelled = "cancelled",
}

export enum ORDER_KIND_ENUM {
  SubscriptionPackage = "subscription_package",
  CreditPlan = "credit_plan",
}

export enum ORDER_DISPLAY_STATUS_ENUM {
  All = "all",
  Paid = "paid",
  Pending = "pending",
  Failed = "failed",
  Abandoned = "abandoned",
  Duplicate = "duplicate",
  Closed = "closed",
}

export enum ORDER_CONFIRMED_BY_ENUM {
  Verify = "verify",
  Poll = "poll",
  Webhook = "webhook",
  Reconciliation = "reconciliation",
}

export enum GATEWAY_PAYMENT_STATUS_ENUM {
  Created = "created",
  Authorized = "authorized",
  Captured = "captured",
  Refunded = "refunded",
  Failed = "failed",
}

export enum WEBHOOK_EVENT_STATUS_ENUM {
  Received = "received",
  Processed = "processed",
  Ignored = "ignored",
  Failed = "failed",
}

export enum DOCUMENT_TYPE_ENUM {
  Invoice = "invoice",
  Receipt = "receipt",
}

export enum CONFIG_VALUE_MODE_ENUM {
  Number = "number",
  Unlimited = "unlimited",
  ContactToSales = "contact_to_sales",
  NotProvided = "not_provided",
}

export enum PACKAGE_CONFIG_KEY_ENUM {
  NumberOfUsers = "number_of_users",
  NumberOfRoles = "number_of_roles",
  NumberOfBranches = "number_of_branches",
  NumberOfFirms = "number_of_firms",
  NumberOfGodowns = "number_of_godowns",
  NumberOfOcrScans = "number_of_ocr_scans",
  NumberOfAiBotRequests = "number_of_ai_bot_requests",
  NumberOfWhatsappCredits = "number_of_whatsapp_credits",
  NumberOfEInvoiceCredits = "number_of_e_invoice_credits",
  NumberOfEWayBillCredits = "number_of_e_way_bill_credits",
  NumberOfAiCredits = "number_of_ai_credits",
  AllowedStockValuationMethods = "allowed_stock_valuation_methods",
}

export enum STOCK_VALUATION_METHOD_ENUM {
  Fifo = "fifo",
  Lifo = "lifo",
  WeightedAverage = "weighted_average",
}

export enum PACKAGE_EDITOR_TAB_ENUM {
  Details = "details",
  Price = "price",
  Limits = "limits",
  Features = "features",
  Claims = "claims",
}

export enum TAX_COMPONENT_ENUM {
  Cgst = "CGST",
  Sgst = "SGST",
  Igst = "IGST",
}

export enum PRICE_CHECK_STATUS_ENUM {
  Empty = "empty",
  InvalidAmount = "invalid_amount",
  InvalidRates = "invalid_rates",
  Valid = "valid",
  Inexact = "inexact",
}

export enum PAYMENT_ALERT_TYPE_ENUM {
  DuplicatePayment = "duplicate_payment",
  AmountMismatch = "amount_mismatch",
  UnknownOrder = "unknown_order",
  LateCapture = "late_capture",
  RefundEvent = "refund_event",
  DisputeEvent = "dispute_event",
  WebhookFailed = "webhook_failed",
  CreditsWhileUnlimited = "credits_while_unlimited",
}

export enum ORDER_HOLD_REASON_ENUM {
  AmountMismatch = "amount_mismatch",
}

export enum ASSIGN_RESULT_ENUM {
  Assigned = "assigned",
  NeedsConfirmation = "needs_confirmation",
  Failed = "failed",
}
